export enum ProductTypeAnalyticsPostfixes {
  NotSpecified = '',
  Arrangement = '_arr',
  Package = '_package',
  Upgrade = '_upgrade',
  AddOn = '_addon',
  Container = '_container',
}
